<template>
  <v-item-group active-class="primary" v-model="model" @change="emitData" v-bind="$attrs">
    <v-row>
        <v-col v-for="(item, key) in items" :key="key" cols="12" :md="cols">
          <v-item v-slot="{ active, toggle }" :value="item.key">
            <v-card v-if="!theme" class="app-card d-flex align-center" height="230" @click="toggle">
              <v-card-text class="text-center" :style="cardActiveStyle(active)">
                <div class="py-4">
                  <v-icon size="40" v-if="svg">
                    {{ wizardIcon(item) }}
                  </v-icon>
                  <v-avatar v-else>
                    <v-img :src="wizardIcon(item)"
                           max-height="60"
                           class="ma-auto"
                           contain
                    />
                  </v-avatar>
                </div>
                <h3>
                  {{ item.name }}
                </h3>
                <h5 v-if="item.subtitle">
                  {{ item.subtitle }}
                </h5>
                <template v-if="pluginsDialog">
                  <p class="mb-1 caption">
                    {{ item.description }}
                    <a href="#" @click.stop.prevent="openDialog(item)" :style="cardActiveStyle(active)">More Info</a>
                  </p>
                </template>
                <gg-btn class="mt-5" tile :color="active ? 'white' : 'primary'" outlined>
                  {{ active ? 'Selected' : 'Select' }}
                </gg-btn>
              </v-card-text>
            </v-card>
            <v-card v-else @click="toggle" class="app-card">
              <v-card-text class="text-center pa-0" :style="cardActiveStyle(active)">
                <v-img :src="`/static/img/wizard/themes/${item.key}.png`"
                       class="d-flex align-center ma-auto"
                       :style="active ? 'border: 1px solid #0ca750' : ''"
                />
                <h5 class="py-2">
                  {{ item.name }}
                </h5>
              </v-card-text>
            </v-card>
          </v-item>
        </v-col>
      <plugin-dialog v-if="dialog"
                     :dialog="dialog"
                     :name="dialogItem.name"
                     :description="dialogItem.description_long"
                     :image-path="wizardIcon(dialogItem)"
                     :website="dialogItem.url"
                     @close="closeDialog"></plugin-dialog>
      </v-row>
  </v-item-group>
</template>

<script>
import { cardActiveStyle, wizardIcon } from '@/helpers/wizard'
import PluginDialog from '@/components/Wizard/StepTwo/PluginDialog'

export default {
  name: 'DataView',
  components: {
    PluginDialog,
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    initialValue: undefined,
    cols: {
      type: [Number, String],
      default: 6
    },
    theme: {
      type: Boolean,
      default: false
    },
    svg: {
      type: Boolean,
      default: false
    },
    pluginsDialog: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    model: undefined,
    dialog: false,
    dialogItem: {},
  }),
  watch: {
    initialValue: function () {
      this.applyInitialData()
    }
  },
  mounted () {
    this.applyInitialData()
  },
  methods: {
    cardActiveStyle,
    applyInitialData () {
      this.model = this.initialValue
    },
    emitData (val) {
      this.$emit('input', val)
    },
    wizardIcon,
    openDialog (item) {
      this.dialogItem = item
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
      this.dialogItem = {}
    },
  },
}
</script>
